export default __webpack_public_path__ + "static/media/ln-white.f9a45e0a.svg";